import { Container, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslate } from 'react-admin';
import CGSaveButton from '../../components/CGSaveButton';
import { Resources } from '../resource';
import styles from './style.module.scss';

interface StaticConfigFormProps {
  config: {
    domain: string;
    hashDomain: string;
    cryptoDomain: string;
    adminDomain: string;
    lobbyDomain: string;
  };
}

const mapSubDomain = {
  hashDomain: 'hash',
  cryptoDomain: 'cryptoft',
  adminDomain: 'admin',
  lobbyDomain: 'da-jupiter',
};

function replaceLast(s: string, s1: string, s2: string) {
  const index = s.lastIndexOf(s1);
  if (index === -1) return s;

  return s.slice(0, index) + s2 + s.slice(index + s1.length);
}

export function StaticConfigForm(props: StaticConfigFormProps) {
  const translate = useTranslate();
  const config = props.config || {};

  const [input, setInput] = useState({
    domain: config.domain || '',
    hash_domain: config.hashDomain || '',
    crypto_domain: config.cryptoDomain || '',
    admin_domain: config.adminDomain || '',
    lobby_domain: config.lobbyDomain || '',
  });

  const canSave =
    input.domain.trim().length > 0 &&
    (input.domain !== config.domain ||
      input.hash_domain !== config.hashDomain ||
      input.crypto_domain !== config.cryptoDomain ||
      input.admin_domain !== config.adminDomain ||
      input.lobby_domain !== config.lobbyDomain);

  function onChangeDomain(domain: string) {
    if (input.domain === domain) return;
    setInput((_prev) => {
      const prev = { ..._prev };
      const oldDomain = prev.domain;
      prev.domain = domain;

      console.log('mylog oldDomain: ', oldDomain);

      if (prev.hash_domain && oldDomain) {
        prev.hash_domain = replaceLast(prev.hash_domain, oldDomain, domain);
      } else {
        prev.hash_domain = `${mapSubDomain.hashDomain}.${domain}`;
      }

      if (prev.crypto_domain && oldDomain) {
        prev.crypto_domain = replaceLast(prev.crypto_domain, oldDomain, domain);
      } else {
        prev.crypto_domain = `${mapSubDomain.cryptoDomain}.${domain}`;
      }

      if (prev.admin_domain && oldDomain) {
        prev.admin_domain = replaceLast(prev.admin_domain, oldDomain, domain);
      } else {
        prev.admin_domain = `${mapSubDomain.adminDomain}.${domain}`;
      }

      if (prev.lobby_domain && oldDomain) {
        prev.lobby_domain = replaceLast(prev.lobby_domain, oldDomain, domain);
      } else {
        prev.lobby_domain = `${mapSubDomain.lobbyDomain}.${domain}`;
      }
      return prev;
    });
  }

  return (
    <Container className={styles.hashGameFormContainer}>
      <Container className={styles.groupInput}>
        <TextField
          label={translate('module.staticConfig.domain')}
          value={input.domain}
          type="text"
          onChange={(event) => onChangeDomain(event.target.value)}
          helperText={translate('module.staticConfig.domainHelper')}
          sx={{ width: 500 }}
        />
        <TextField
          label={translate('module.staticConfig.hashDomain')}
          value={input.hash_domain}
          type="text"
          onChange={(event) => setInput((prev) => ({ ...prev, hash_domain: event.target.value }))}
          helperText={translate('module.staticConfig.hashHelper')}
          sx={{ width: 500 }}
        />
        <TextField
          label={translate('module.staticConfig.cryptoDomain')}
          value={input.crypto_domain}
          type="text"
          onChange={(event) => setInput((prev) => ({ ...prev, crypto_domain: event.target.value }))}
          helperText={translate('module.staticConfig.cryptoHelper')}
          sx={{ width: 500 }}
        />
        <TextField
          label={translate('module.staticConfig.adminDomain')}
          value={input.admin_domain}
          type="text"
          onChange={(event) => setInput((prev) => ({ ...prev, admin_domain: event.target.value }))}
          helperText={translate('module.staticConfig.adminHelper')}
          sx={{ width: 500 }}
        />
        <TextField
          label={translate('module.staticConfig.lobbyDomain')}
          value={input.lobby_domain}
          type="text"
          onChange={(event) => setInput((prev) => ({ ...prev, lobby_domain: event.target.value }))}
          helperText={translate('module.staticConfig.lobbyHelper')}
          sx={{ width: 500 }}
        />

        <CGSaveButton
          className={styles.button}
          resource={Resources.staticConfig}
          type="create"
          variant="contained"
          color="success"
          data={input}
          message={{ success: 'message.configSaved' }}
          disabled={!canSave}
        />
      </Container>
    </Container>
  );
}
